import React from 'react';
import Moment from 'react-moment';
import {shouldCheckIndicatorAge} from '../utils/indicator_utils';
import {isTimeOver12hrs} from '../utils/time_utils';

import './ActiveIndicatorMessage.css';
import MessageBox from './MessageBox';

class ActiveIndicatorMessage extends React.Component {
  render() {
    const { active_indicator, time } = this.props;

    const warnings = [];
    const messages = [];

    let date_updated_class = 'date-updated';
    if (active_indicator &&
        shouldCheckIndicatorAge(active_indicator) &&
        isTimeOver12hrs(active_indicator.creationTime)) {
      date_updated_class += ' too-old';
      warnings.push(<div>The data layer you have selected is displaying data that is &gt; 12 hours out-of-date.</div>);
    }

    if (time.selected_time) {
      messages.push(
        <React.Fragment>
          {(active_indicator && time.display_time) && <div>
            {'Indicator: '}
            <span className="emphasis">
                    {active_indicator.displayName}
                  </span>
          </div>}
          {(active_indicator && !time.display_time) && <div>
            <span>No forecast data for </span>
            <strong>{active_indicator.displayName}</strong>
            <span> for </span>
            <strong><Moment tz="Australia/Melbourne"
                            format=" dddd DD/MM/YYYY HH:mm ">{time.selected_time}</Moment></strong>
          </div>}
          <div>
            Selected time:
            <span className="emphasis">
                    <Moment tz="Australia/Melbourne"
                            format=" HH:mm ddd D/MM YYYY">{time.selected_time}
                    </Moment>
                  </span>
          </div>
          {active_indicator &&
           <div className={date_updated_class}>
             Data updated:
             <span className="emphasis">
                    <Moment tz="Australia/Melbourne"
                            format=" HH:mm ddd D/MM YYYY">{active_indicator.creationTime}
                    </Moment>
                  </span>
           </div>}
          <div className="print-only">
            Printed at:
            <span className="emphasis">
                    <Moment tz="Australia/Melbourne"
                            format=" HH:mm ddd D/MM YYYY">{new Date()}
                    </Moment>
                  </span>
          </div>
        </React.Fragment>
      );
    }

    return (
      <div className="c-active-indicator-message">
        <MessageBox warning={true} messages={warnings}/>
        <MessageBox messages={messages}/>
      </div>
    );
  }
}

export default ActiveIndicatorMessage;



// WEBPACK FOOTER //
// ./src/components/ActiveIndicatorMessage.js